<template>
  <div class="container has-text-centered" v-if="clock.datetimeMoment">
    <div class="column is-6 is-offset-3 content">

      <div>
        <img :src="logo" class="logo" />
      </div>
      <h1>
        {{ $t('message.title') }}
      </h1>
      <div>
        {{ formattedDate }}
      </div>

      <div class="clock" style="margin-top: -1.5rem;">
        {{ formattedTime }}
      </div>

      <Keyboard is-mask @onSubmit="onHRSubmit"></Keyboard>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import toaster from './toaster'
import PunchVue from './Punch'
import Keyboard from "@/Keyboard";

export default {
  components: {
    Keyboard,
  },
  data() {
    return {
      clock: {
        datetimeMoment: null,
      },
    }
  },
  computed: {
    logo() {
      const cieCode = localStorage.getItem('cie_code')
      return `/api/v1/cie/logo/${cieCode}`
    },
    formattedDate() {
      return this.clock.datetimeMoment.format('YYYY-MM-DD')
    },
    formattedTime() {
      return this.clock.datetimeMoment.format('HH:mm:ss')
    },
  },
  mounted() {
    this.updateClock()
  },
  methods: {
    updateClock() {
      this.clock.datetimeMoment = moment()
      setTimeout(this.updateClock, 1000)
    },
    onHRSubmit(pin, callback) {
      const code = localStorage.getItem('cie_code')
      if (!code) {
        return this.$router.push({path: '/ui/cie'})
      }
      return axios.post('/api/v1/hr/info', {code: code, pin: pin}).then(res => {
        return new Promise(resolve => {
          this.$buefy.modal.open({
            parent: this,
            component: PunchVue,
            props: {
              datetimeMoment: this.clock.datetimeMoment,
              code: code,
              pin: pin,
              hrInfo: res.data
            },
            hasModalCard: true
          }).$on('close', resolve)
        })
      }).catch(toaster.catch(this)).finally(() => {
        callback();
      })
    }
  }
}
</script>
